import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getRedeemBalanceRequest,
  getRedeemBalanceSuccess,
  getRedeemBalanceFailure,
  getPendingRedeemRequest,
  getPendingRedeemSuccess,
  getPendingRedeemFailure,
  cancelRedeemOrderRequest,
  cancelRedeemOrderSuccess,
  cancelRedeemOrderFailure,
  createRedeemOtpRequest,
  createRedeemOtpSuccess,
  createRedeemOtpFailure,
} from "./redeemSlice";
import { toast } from "react-toastify";

function* fetchRedeemBalance() {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/redeem/getRedeemBalance`
      )
    );

    if (response.data.success) {
      yield put(getRedeemBalanceSuccess(response.data));
      // toast.success("Redeem balance fetched successfully");
    } else {
      yield put(
        getRedeemBalanceFailure(
          response.data.message || "Failed to fetch redeem balance"
        )
      );
      toast.error(response.data.message || "Failed to fetch redeem balance");
    }
  } catch (error) {
    yield put(getRedeemBalanceFailure(error.message));
    toast.error("Error fetching redeem balance");
  }
}

function* fetchPendingRedeem(action) {
  try {
    const { id, type } = action.payload;

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/redeem/pendingredeemorder`,
        { id, type }
      )
    );

    if (response.data.success) {
      yield put(getPendingRedeemSuccess(response.data));
      // toast.success("Pending redeem orders fetched successfully");
    } else {
      yield put(getPendingRedeemFailure(response.data.message));
      toast.error(response.data.message || "Failed to fetch pending orders");
    }
  } catch (error) {
    yield put(getPendingRedeemFailure(error.message));
    toast.error(error.message || "Error fetching pending orders");
  }
}

function* cancelRedeemOrder(action) {
  try {
    const { id } = action.payload;

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/redeem/cancelredeemorder/${id}`
      )
    );

    if (response.data.success) {
      yield put(cancelRedeemOrderSuccess(response.data));
      toast.success(response.data.message || "Redeem order cancelled");
      if (action.payload.onSuccess) {
        action.payload.onSuccess();
      }
    } else {
      yield put(cancelRedeemOrderFailure(response.data.message));
      toast.error(response.data.message || "Failed to cancel order");
    }
  } catch (error) {
    yield put(cancelRedeemOrderFailure(error.message));
    toast.error(error.message || "Error cancelling redeem order");
  }
}

function* createRedeemOtp(action) {
  try {
    const body = action.payload;

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/redeem/createredeemotp`,
        body
      )
    );

    if (response.data.success) {
      yield put(createRedeemOtpSuccess(response.data));
      if (action.payload.onSuccess) {
        action.payload.onSuccess();
      }
      yield put(getRedeemBalanceRequest());
      toast.success(response.data.message || "Redeem OTP created successfully");
    } else {
      yield put(createRedeemOtpFailure(response.data.message));
      toast.error(response.data.message || "Failed to create redeem OTP");
    }
  } catch (error) {
    yield put(createRedeemOtpFailure(error.message));
    toast.error(error.message || "Error creating redeem OTP");
  }
}

export function* redeemSaga() {
  yield takeLatest(getRedeemBalanceRequest.type, fetchRedeemBalance);
  yield takeLatest(getPendingRedeemRequest.type, fetchPendingRedeem);
  yield takeLatest(cancelRedeemOrderRequest.type, cancelRedeemOrder);
  yield takeLatest(createRedeemOtpRequest.type, createRedeemOtp);
}
